interface HeaderAvatarsProps {
  userInitial: string;
  partnerInitial: string;
  partnerJoined: boolean;
  onInviteClick: () => void;
}

export function HeaderAvatars({ userInitial, partnerInitial, partnerJoined, onInviteClick }: HeaderAvatarsProps) {
  if (partnerJoined) {
    return (
      <div className="flex items-center pr-2">
        <div className="w-9 h-9 rounded-full bg-[#7a8b6e] border-2 border-[#f5f2eb] flex items-center justify-center text-white text-sm font-semibold relative z-10">
          {userInitial}
        </div>
        <div className="w-9 h-9 rounded-full bg-[#c4a47a] border-2 border-[#f5f2eb] flex items-center justify-center text-white text-sm font-semibold -ml-2.5 relative z-0">
          {partnerInitial}
        </div>
      </div>
    );
  }

  return (
    <button onClick={onInviteClick} className="flex items-center">
      <div className="w-9 h-9 rounded-full bg-[#7a8b6e] border-2 border-[#f5f2eb] flex items-center justify-center text-white text-sm font-semibold relative z-10">
        {userInitial}
      </div>
      <div className="w-8 h-8 rounded-full border-[1.5px] border-dashed border-[#7a8b6e] bg-[rgba(232,228,219,0.6)] flex items-center justify-center -ml-2">
        <span className="text-[#7a8b6e] text-xs font-semibold">+</span>
      </div>
    </button>
  );
}
